import { getIntroIntakeFormApiEndPoint } from '@shared';
import { useSelector } from 'react-redux';
import { selectSessionAdvisor } from '@/model/selectors';
import { OptionalSettingsFields } from './OptionalSettingsFields';
import { useForm, FormProvider } from 'react-hook-form';
import { CopyLinkField } from './CopyLinkField';

type IntakeFormLinkProps = {
  className?: string;
};

interface IntakeFormData {
  sendClientResultsLink: boolean;
  selectedReferralSourceId?: string;
  clientRelationshipStage: undefined;
}

export function IntakeFormLinkModalContent({ className }: IntakeFormLinkProps) {
  const advisor = useSelector(selectSessionAdvisor);
  const { advisorId, sendClientResultsLinkSetting } = advisor;

  const methods = useForm<IntakeFormData>({
    defaultValues: {
      sendClientResultsLink: sendClientResultsLinkSetting ?? false,
      selectedReferralSourceId: undefined,
      clientRelationshipStage: undefined,
    },
  });

  const { watch } = methods;

  const sendClientResultsLink = watch('sendClientResultsLink');
  const referralSourceId = watch('selectedReferralSourceId');

  const intakeFormUrl = `${getIntroIntakeFormApiEndPoint(
    advisorId,
    sendClientResultsLink,
    undefined,
    referralSourceId,
  )}`;

  return (
    <FormProvider {...methods}>
      <div className={className}>
        <CopyLinkField
          label="Intake Form Link"
          url={intakeFormUrl}
          tooltipContent={
            <div className="text-sm font-normal">
              <p>
                This link can be shared with multiple clients. Each will receive
                a unique Intake Form
              </p>
            </div>
          }
        />

        <OptionalSettingsFields
          contentClassName="mt-4"
          hideRelationshipStage={true}
        />
      </div>
    </FormProvider>
  );
}
